<div class="dashboard-setting">
  @if (dashboardData && dashboardData.length && dashboardData.length > 1) {
    <section class="dash-container">
      <mat-divider class="pb-24"></mat-divider>
      <div class="savebtn">
        <button mat-raised-button color="primary" (click)="savebtn()">SAVE</button>
      </div>
      <app-admin-grid-table [dataSource]="dashboardData" [appRoles]="appRoles"></app-admin-grid-table>
    </section>
  }
</div>
